import React  from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { sendAnalyticsEvents } from '../../analytics/common'
import { EVENTS } from '../../analytics/events'
import { selectPlace } from './familySlice'
import { selectEventsData } from '../events/eventsSlice'
import UIButton from '../../UI/UIButton'
import MainHeadline from '../../UI/MainHeadline';
import MainDescription from '../../UI/MainDescription';


const ModalCover = styled.div`
    position: fixed;
    top: -5vh;
    left: 0;
    width: 100vw;
    height: 110vh;
    background: rgba(0,0,0,.56);
    z-index: 1000;
`;

const StyledPopup = styled.div`
    width: min(327px,95vw);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: #FFFFFF;
    border-radius: 48px;
`;

const PopupHead = styled.div`
    height: 153px;
    background: url(../assets/popup-head.png) center / cover no-repeat;
    border-radius: 48px 48px 0 0;
`;

const PopupBody = styled.div`
    padding: 24px;
`;

const PlaceAddedPopup = ({ history }) => {
    const { t } = useTranslation();
    const place = useSelector(selectPlace);
    const eventsData = useSelector(selectEventsData);

    const onContinueClick = () => {
        sendAnalyticsEvents(EVENTS.onboardingPlaceaddedSubmitted, eventsData);
        history.push('/signup')
    };

    return (
        <ModalCover>
            <StyledPopup>
                <PopupHead />
                <PopupBody>
                    <MainHeadline customMargin={'0 0 16px'}>{t(`${place || 'home'}_is_added`)}</MainHeadline>
                    <MainDescription>{t('place_description')}</MainDescription>
                    <UIButton onClick={onContinueClick} customMargin={'32px 0 0'} />
                </PopupBody>
            </StyledPopup>
        </ModalCover>
    )
};

export default PlaceAddedPopup
